import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';

import {
  getSupplierJobsSuccessAction,
  setSupplierJobsIsLoadingAction,
  createSupplierJobSuccessAction,
  updateSupplierJobSuccessAction,
  setSupplierJobsCountAction,
  getSupplierJobsPendingSuccessAction,
  deleteJobSuccessAction,
  getSingleSupplierJobSuccessAction,
  updateSupplierApplicantStatusSuccessAction
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';

function* createSupplierJob({ payload }) {
  if (payload.skills) payload.skills = payload.skills.split(',');

  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.createSupplierJob, payload);
    const { data } = response;
    const job = data;
    yield put(createSupplierJobSuccessAction(job));
    yield put(newSuccessNotificationAction(`Job Created : ${job.title}`));

    yield put(push('/jobs/supplier/pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* updateAtrisanJob({ payload: { id, formData } }) {
  if (formData.skills) formData.skills = formData.skills.split(',');
  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.updateSupplierJob, id, formData);
    const { data } = response;
    const updatedJob = data;
    yield put(updateSupplierJobSuccessAction(updatedJob));
    yield put(newSuccessNotificationAction(`Updated Job : ${updatedJob.name}`));
    yield put(push('/supplier-jobs/pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* getSupplierJobs({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '0'
      }
    ],
    filterSupplier: payload?.supplierId,
    filterSupplierCategory: '',

    sort: 'createdAt',
    dir: 'desc',
    profileId: payload?.supplierId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.getSupplierJobs, body);
    const { data } = response;

    const count = data.count;
    const supplierJobs = data.content;

    yield put(setSupplierJobsCountAction(count));
    yield put(getSupplierJobsSuccessAction(supplierJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* getSingleJob({ payload }) {
  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.getSingleSupplierJob, payload);
    const { data } = response;

    const supplierJob = data;

    yield put(getSingleSupplierJobSuccessAction(supplierJob));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* getSupplierPendingJobs({ payload }) {
  console.log(payload, 'payloadpayload');
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '0'
      }
    ],
    filterSupplier: payload?.supplierId,
    filterSupplierCategory: '',
    sort: 'createdAt',
    dir: 'desc',
    profileId: payload?.supplierId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.getSupplierPendingJobs, body);
    const { data } = response;

    const count = data.count;
    const supplierJobs = data.content;

    yield put(setSupplierJobsCountAction(count));
    yield put(getSupplierJobsPendingSuccessAction(supplierJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* updateSupplierStatus({ payload }) {
  if (payload.skills) payload.skills = payload.skills.split(',');
  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    const response = yield call(api.putUpdateApplicantStatus, payload);
    const { data } = response;

    yield put(updateSupplierApplicantStatusSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

function* deleteJob({ payload }) {
  try {
    yield put(setSupplierJobsIsLoadingAction(true));
    yield call(api.deleteSupplierJob, payload);

    yield put(deleteJobSuccessAction(payload));
    yield put(newSuccessNotificationAction('Job Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierJobsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_JSUPPLIER, getSupplierJobs);
  yield takeLatest(actions.GET_JSUPPLIER_PENDING, getSupplierPendingJobs);
  yield takeLatest(actions.CREATE_JSUPPLIER, createSupplierJob);
  yield takeLatest(actions.UPDATE_JSUPPLIER, updateAtrisanJob);
  yield takeLatest(actions.DELETE_JSUPPLIER, deleteJob);
  yield takeLatest(actions.GET_SINGLE_JSUPPLIER, getSingleJob);
  yield takeLatest(
    actions.UPDATE_JSUPPLIER_APPLICANT_STATUS,
    updateSupplierStatus
  );
}
